import { View, Text, Image } from "react-native";
import { SvgXml } from "react-native-svg";
import { Token } from "../types/Problem";
import { exampleXml, tokens } from "../utils/exampleLatex";
import Xml from "./Xml";

const TokenComponent = ({ token }: { token: Token }) => {
	let xml = "";
	let width = 0;
	let height = 0;

	if (token.type === "TextToken") {
		return (
			<>
				{token.text.split(" ").map((word, index) => {
					return (
						<Text
							key={index}
							className="text-xl text-white text-justify"
						>
							{word + " "}
						</Text>
					);
				})}
			</>
		);
	} else if (
		token.type === "LatexInlineToken" ||
		token.type === "LatexBlockToken"
	) {
		xml = token.xml;
		if (xml.length === 0) {
			return <Text></Text>;
		}

		xml = xml
			.replace('fill="currentColor"', 'fill="white"')
			.replace("fill: black", "fill: white");

		const start = xml.indexOf("<svg"); // Remove useless stuff before the svg tag

		const regex = /width="([^"]*)" height="([^"]*)"/;

		const result = regex.exec(xml);
		if (result) {
			const w = result[1];
			const h = result[2];
			width = parseFloat(w.slice(0, w.length - 2)) * 1;
			height = parseFloat(h.slice(0, h.length - 2)) * 1;

			xml = xml.slice(start);
		}

		let heightPixels = height * 10;
		let widthPixels = width * 10;

		if (widthPixels > 300) {
			const ratio = widthPixels / 300;
			widthPixels = 300;
			heightPixels = heightPixels / ratio;
		}

		if (token.type === "LatexBlockToken") {
			return (
				<View className="w-full my-2 items-center justify-center">
					<Xml
						xml={xml}
						widthPixels={widthPixels}
						heightPixels={heightPixels}
					/>
				</View>
			);
		}
		return (
			<>
				<Xml
					xml={xml}
					widthPixels={widthPixels}
					heightPixels={heightPixels}
				/>
				<Text> </Text>
			</>
		);
	} else if (token.type === "ImageUrlToken") {
		if (token.url) {
			return (
				<>
					{/* Per andare a capo */}
					<View className="basis-full h-0"></View>
					<View className="flex-row basis-full justify-center mt-4">
						<Image
							style={{ height: 200, width: 200 }}
							resizeMode="contain"
							source={{ uri: token.url }}
							className="bg-white"
						/>
					</View>
					<View className="basis-full h-0"></View>
				</>
			);
		}
	}
	return <View></View>;
};

export default TokenComponent;
